import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import { sortDataByOrder } from "../../utils/helper";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import CardList from "./newUx/CardList/CardList";


export default function ApprenticeshipsComponent() {
  const navigate = useNavigate();
  const [, setLoading] = useState(true);
  const localData = useSelector((state) => state?.localStorage)
  const { micrositeID, tabConfigId } = localData
  const [activeKey,] = useState("apprenticeship");
  const [responseData, setResponseData] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [mediaType, setMediaType] = useState("");
  const color = ["#E75E0D", "#EB9F11", "#ABC710", "#009340", "#CC0370", "#8366A9", "#149BD7"];
  const id = micrositeID;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getApprenticeshipData = async (activeKey, id) => {
    try {
      setLoading(true);

      if (id) {
        const response = await getRequest(
          userapiservice.getMicrositeDetailsVacancyTab(id, "PART_TIME", tabConfigId),
          null,
          false
        );
        setResponseData(sortDataByOrder(response));
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)

    }
    finally {
      setLoading(false);
    }
  };

  const PlayVideoHandler = (url, mediaType) => {
    setMediaType(mediaType)
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const convertToStandardURL = (shortUrl) => {
    if (shortUrl?.indexOf('youtu.be') !== -1) {
      const video_id = shortUrl?.split('youtu.be/')[1].split('?')[0];
      return `https://www.youtube.com/watch?v=${video_id}`;
    }
    return shortUrl;
  }

  const onCardClickHandler = (data) => {
    navigate(`/microsite/${data.id}/micrositeDetails`, {
      state: { page: activeKey, data: data },
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };

  useEffect(() => {
    getApprenticeshipData(activeKey, id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, id]);

  return (
    <>
      <CardList
        responseData={responseData}
        color={color}
        PlayVideoHandler={PlayVideoHandler}
        convertToStandardURL={convertToStandardURL}
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
        videoUrl={videoUrl}
        mediaType={mediaType}
        onCardClickHandler={onCardClickHandler}
      />
    </>
  )
}
